const INDEX = {
    INDEX_AXIOS_VIDEO_CLUB: {
        actions_type: "INDEX_AXIOS_VIDEO_CLUB",
        mutations_type: "index_axios_video_club"
    },
    INDEX_AXIOS_HOT_CLUB: {
        actions_type: "INDEX_AXIOS_HOT_CLUB",
        mutations_type: "index_axios_hot_club"
    },
    INDEX_AXIOS_FOCUS_POST: {
        actions_type: "INDEX_AXIOS_FOCUS_POST",
        mutations_type: "index_axios_focus_post"
    },
    INDEX_SAVE_DATA: {
        actions_type: "INDEX_SAVE_DATA",
        mutations_type: "index_save_data"
    },
    INDEX_AXIOS_GET: {
        actions_type: "INDEX_AXIOS_GET",
        mutations_type: "index_axios_get"
    }
}

const ARTICLE = {
    ARTICLE_POST_INFO: {
        actions_type: "ARTICLE_POST_INFO",
        mutations_type: "article_post_info"
    },
    ARTICLE_POST_COMMENT: {
        actions_type: "ARTICLE_POST_COMMENT",
        mutations_type: "article_post_comment"
    },
    ARTICLE_USER_INFO: {
        actions_type: "ARTICLE_USER_INFO",
        mutations_type: "article_user_info"
    },
    ARTICLE_USER_POST: {
        actions_type: "ARTICLE_USER_POST",
        mutations_type: "article_user_post"
    },
    ARTICLE_AXIOS_GET: {
        actions_type: "ARTICLE_AXIOS_GET",
        mutations_type: "article_axios_get"
    }
}

module.exports = {
    INDEX,
    ARTICLE
}